(function () {
  'use strict';
  function boot() {
    var launch = document.querySelector('[data-tb-viewer-launch]');
    var title = document.querySelector('.product__title') || document.querySelector('#MainContent h1');
    if (!launch || !title || launch.dataset.bound) return;
    launch.dataset.bound = 'true';
    title.insertAdjacentElement('afterend', launch);
    launch.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
